export enum ContactType_Enum
{
    Email = 1,
    Text = 2,
    WhatsApp = 3
}